import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {AppVersionService} from '../../../services/app-version.service';

/**
 * Tells a user with an open tab that a newer build has been deployed (REN-6298). It stays until
 * they reload: a toast would time out while the tab keeps running the old build.
 */
@Component({
  selector: 'new-version-banner',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div role="status" aria-live="polite">
      @if (version.updateAvailable()) {
        <div id="new-version-banner"
             class="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 flex items-center gap-4 w-max max-w-[calc(100vw-2rem)] py-2.5 pl-4 pr-3 text-sm text-[#1f2937] bg-white border border-[#e5e7eb] border-l-[8px] border-l-[#fdde63] rounded-[6px] shadow-lg">
          <p class="m-0"><span class="font-bold">A new version of the portal is available.</span> Save your work, then reload.</p>
          <button type="button" id="new-version-reload"
                  class="inline-flex items-center justify-center min-h-[34px] px-7 py-1.5 text-xs font-semibold leading-[1.2] whitespace-nowrap text-black bg-[#fdde63] hover:bg-[#f2c94c] border border-transparent rounded-[4px] cursor-pointer"
                  (click)="version.reload()">
            Reload
          </button>
        </div>
      }
    </div>
  `,
})
export class NewVersionBannerComponent {
  protected readonly version = inject(AppVersionService);

  constructor() {
    this.version.start();
  }
}
